/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-runloop */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { sort } from '@ember/object/computed';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import {
  cleanExcelSheetName,
  cleanFileName,
  uniqueSheetName,
} from '@linc-technologies/linced-common/utils/file-names';
import { naturalSort } from '@linc-technologies/linced-common/utils/sorting';
import { tablePrintCss } from 'linced-app/utils/table';
import moment from 'moment';
import { filterBy, mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class EldestYoungestClassController extends Controller {
  @service
  excel;

  queryParams = ['filter'];
  @tracked
  sortProp = 'lastName';
  @tracked
  sortDir = 'asc';

  @computed('filter')
  get title() {
    return `${
      this.filter === 'eldest' ? 'Eldest' : 'Youngest'
    } in the Family Class Lists`;
  }

  @computed('filter', 'model.homerooms.[]')
  get filteredHomerooms() {
    let field = 'isYoungest';
    if (this.filter === 'eldest') {
      field = 'isEldest';
    }
    return this.model.homerooms.map((homeroom) => {
      return {
        name: homeroom.name,
        learners: mapBy(
          filterBy(homeroom.currentLearners, `person.learner.${field}`),
          'person',
        ),
      };
    });
  }

  @sort('filteredHomerooms', naturalSort('name'))
  sortedHomeRooms;

  @action
  onChangeSort({ sortProp, sortDir }) {
    this.sortProp = sortProp;
    this.sortDir = sortDir;
  }

  @action
  downloadFullXlsx() {
    let sheets = [];
    let sheetNames = [];

    this.sortedHomeRooms.forEach((homeroom) => {
      let sheetName = uniqueSheetName(
        cleanExcelSheetName(homeroom.name),
        sheetNames,
      );
      sheetNames.push(sheetName);

      sheets.push({
        name: sheetName,
        data: this.getExportData(homeroom),
      });
    });

    let fileName = `${this.title} ${moment().format('YYYY-MM-DD')}.xlsx`;

    this.excel.export(sheets, {
      multiSheet: true,
      fileName: cleanFileName(fileName),
    });
  }

  @action
  print() {
    let printer = window.open(
      'about:blank',
      '_blank',
      'menubar=yes,location=no,resizable=yes,scrollbars=yes,status=no,height=700,width=1024',
    );
    let classLists = document.querySelectorAll('.class-list');
    let content = tablePrintCss;

    content += `<style>.table-tools button { display: none; }</style>`;

    classLists.forEach((classList, index) => {
      if (index !== 0) {
        content += `<div style="page-break-before: always"></div>`;
      }

      content += classList.outerHTML;
    });

    printer.document.body.innerHTML = content;

    later(
      this,
      (printer) => {
        printer.print();
        printer.close();
      },
      printer,
      500,
    );
  }

  getExportData(homeroom) {
    let data = [];

    // Class info
    data.push(
      [`${homeroom.name}`],
      [`Total number of students: ${homeroom.learners.length}`],
    );

    // Column headers
    data.push([
      'Last Name',
      `First Name (${
        this.filter === 'eldest' ? 'Eldest' : 'Youngest'
      } in family)`,
      'Year Level',
    ]);

    // Data
    homeroom.learners.forEach((learner) => {
      data.push([
        learner.lastName,
        learner.firstName,
        learner.currentYearLevel,
      ]);
    });

    return data;
  }
}
